export const requiredField = (label: string) => `${label}*`;
